const config = {
    development: {
      serverUrl: "https://dev-panel-backend.mobilityinfotech.com",
      // serverUrl: "http://localhost:8006",
      operationsUrl: "https://dev-patch-opr.mobilityinfotech.com",
      // operationsUrl: "http://localhost:8005",
      // autosUrl: "https://dev.togopool.com:8003"
      autosUrl: "https://dev-taxi-central.mobilityinfotech.com"
    },
    production: {
      serverUrl: "https://dev-panel-backend.mobilityinfotech.com",
      operationsUrl: "https://dev-patch-opr.mobilityinfotech.com"
    },
  };
  
  // Export the config based on the current environment
  const environment = process.env.NODE_ENV || 'development';
  export default config[environment];
  